// Batch 34 · fork L: S18 — a 3203-07 row sent to Misstatements with no stored answer stays omitted ("answer missing - sent as
// omitted"); S19 — the AP aging keeps a retention payable in or out by the aging, and a concluded worksheet whose
// classification changed is flagged. EN + AR, merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B34L = {
  en: {
    b34l: {
      answerMissing: "Answer missing - sent as omitted",
      answerMissingHint: "This row was sent to Misstatements before its answer was stored. It stays omitted for the amount sent; give the answer to change it.",
      agingIn: "In the aging listing",
      agingOut: "Not in the aging listing",
      changedTitle: "Classification changed after conclusion",
      changedText: "The trade classification changed after this worksheet was concluded. Reopen it, review the Trade tick of the accounts listed, and conclude again.",
      changedAt: "Concluded {d}",
      diffThen: "Difference at conclusion: {v}",
      diffNow: "Difference now: {v}",
      wasTrade: "was trade", wasNot: "was not trade", nowTrade: "now trade", nowNot: "now not trade",
      needsClass: "needs classification",
    },
  },
  ar: {
    b34l: {
      answerMissing: "الإجابة غير محفوظة - أُرسل كمحذوف",
      answerMissingHint: "أُرسل هذا الصف إلى التحريفات قبل حفظ إجابته. يبقى محذوفًا بالمبلغ المُرسل؛ أدخل الإجابة لتغييره.",
      agingIn: "مدرج في تقرير الأعمار",
      agingOut: "غير مدرج في تقرير الأعمار",
      changedTitle: "تغيّر التصنيف بعد الاستنتاج",
      changedText: "تغيّر تصنيف الحسابات التجارية بعد استنتاج ورقة العمل هذه. أعد فتحها، وراجع خانة \"تجاري\" للحسابات المذكورة، ثم أعد الاستنتاج.",
      changedAt: "تاريخ الاستنتاج {d}",
      diffThen: "الفرق عند الاستنتاج: {v}",
      diffNow: "الفرق الآن: {v}",
      wasTrade: "كان تجاريًا", wasNot: "لم يكن تجاريًا", nowTrade: "أصبح تجاريًا", nowNot: "أصبح غير تجاري",
      needsClass: "يحتاج إلى تصنيف",
    },
  },
};

export default I18N_B34L;
